var site = window.site || {};
var mediumInterval = 500;
var shortInterval = 300;
var shorterInterval = 200;
var shortestInterval = 100;

(function ($) {
  Drupal.behaviors.foundationFinderQuizV3 = {
    isMobile: false,
    isMedium: false,
    selector: {
      slides: '.js-foundation-finder--quiz-slide',
      quiz: '.js-foundation-finder--quiz',
      title: '.js-foundation-finder-title',
      legal: '.js-foundation-finder-legal-update',
      quickMatch: '.js-foundation-finder--quiz__quick-match-cta',
      quickMatchWrapper: '.js-foundation-finder--quiz-quick-match',
      quickMatchHeader: '.js-foundation-finder--quiz__results-header-quickmatch',
      resultsHeader: '.js-foundation-finder--quiz__results-header',
      question: '.js-foundation-finder--quiz-question',
      carousel: '.js-foundation-finder--quiz-carousel',
      carouselWrapper: '.js-foundation-finder--quiz__carousel-wrapper',
      navItems: '.js-foundation-finder--quiz__nav-item',
      navItemText: '.js-foundation-finder--quiz__nav-value',
      navMenu: '.js-foundation-finder--quiz__nav-menu',
      answer: '.js-foundation-finder--quiz-answer',
      buttonNext: '.js-foundation-finder--quiz-button--next',
      buttonResults: '.js-foundation-finder--quiz-button--results',
      landingStep: '.js-foundation-finder--quiz__slide--tout',
      modelsCarousel: '.js-foundation-finder__models-carousel',
      modelsCarouselFormatter: '.js-foundation-finder__carousel-formatter',
      footerContainer: '.js-foundation-finder--quiz__footer',
      resetQuizBtn: '.js-foundation-finder--quiz__start-over',
      mobileNavItems:
        '.js-foundation-finder--quiz__nav-menu .js-foundation-finder--quiz-button--results, ' +
        '.js-foundation-finder--quiz__nav-menu .js-foundation-finder--quiz-button--next'
    },

    settings: {
      speed: 950,
      infinite: false,
      arrows: false,
      swipe: false,
      draggable: false,
      touchMove: false,
      accessibility: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      vertical: true
    },

    attach: function (context) {
      var self = this;

      if (!!Unison.fetch.now()) {
        self.isMobile = self.checkIfMobile();
        self.isMedium = self.checkIfMedium();
      }
      self.setup(context);
    },

    getDom: function ($that) {
      var self = this;

      $that.nodes = {};
      $that.nodes.$title = $(self.selector.title, $that);
      $that.nodes.$legal = $(self.selector.legal, $that);
      $that.nodes.$quickMatchWrapper = $(self.selector.quickMatchWrapper, $that);
      $that.nodes.$quickMatchHeader = $(self.selector.quickMatchHeader, $that);
      $that.nodes.$resultsHeader = $(self.selector.resultsHeader, $that);
      $that.nodes.$mobileNavItems = $(self.selector.mobileNavItems, $that);
      $that.nodes.$navMenu = $(self.selector.navMenu, $that);
      $that.nodes.$buttonNext = $(self.selector.buttonNext, $that);
      $that.nodes.$buttonResults = $(self.selector.buttonResults, $that);
      $that.nodes.$quickMatch = $(self.selector.quickMatch, $that);
      $that.nodes.$carousel = $(self.selector.carousel, $that);
      $that.nodes.$carouselWrapper = $(self.selector.carouselWrapper, $that);
      $that.nodes.$navItems = $(self.selector.navItems, $that);
      $that.nodes.$navItemText = $(self.selector.navItemText, $that);
      $that.nodes.$slides = $(
        self.selector.slides + ':not(' + self.selector.landingStep + ')',
        $that
      );
      $that.nodes.$question = $that.nodes.$carousel.find(self.selector.question);
      $that.nodes.$answer = $that.nodes.$carousel.find(self.selector.answer);
      $that.nodes.$landingStep = $(self.selector.landingStep, $that);
      $that.nodes.$modelsCarousel = $(self.selector.modelsCarousel, $that);
      $that.nodes.$modelsCarouselFormatter = $(self.selector.modelsCarouselFormatter, $that);
      $that.nodes.$footerContainer = $(self.selector.footerContainer, $that);
      $that.nodes.$resetQuizBtn = $(self.selector.resetQuizBtn, $that);
    },

    setup: function (context) {
      var self = this;
      var $quiz = $(self.selector.quiz, context);

      Unison.on('change', function () {
        var isDesktop = !self.isMobile && !self.isMedium;

        self.isMobile = self.checkIfMobile();
        self.isMedium = self.checkIfMedium();
        if (isDesktop !== !self.isMobile && !self.isMedium) {
          self.swapLayout($quiz);
        }
      });
      self.getDom($quiz);
      self.initLandingStep($quiz);
      self.initQuizLayout($quiz);
      self.setEvents($quiz);
    },

    initLandingStep: function ($that) {
      var self = this;

      if ($that.nodes.$landingStep.length > 0) {
        self.disableButtons($that);
        $that.nodes.$carousel.css({ height: 0 }).removeClass('hidden');
      }
    },

    checkIfMobile: function () {
      var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
      var bPlargeUp = parseInt(Unison.fetch.all()['medium'], 10);

      return currentBpWidth < bPlargeUp;
    },

    checkIfMedium: function () {
      var currentBpWidth = parseInt(Unison.fetch.now().width, 10);
      var bPlargeUp = parseInt(Unison.fetch.all()['largeLandscape'], 10);

      if (currentBpWidth === 0) {
        return false;
      }

      return currentBpWidth < bPlargeUp;
    },

    swapLayout: function ($that) {
      var self = this;

      self.resetLayout($that);
      self.initQuizLayout($that);
      self.setEvents($that);
    },

    resetLayout: function ($that) {
      $that.data('layout', '').removeClass('ff-quiz-layout--accordion ff-quiz-layout--carousel');
      $that.nodes.$navItems.removeClass('expanded accordion-layout-processed');
      // We reset the inline display, need to allow css rules to take over.
      $that.nodes.$slides.css({ display: '' });
      // We detach first to clean only quiz slick html and not the inner slicks.
      $that.nodes.$slides.detach();
      if ($that.nodes.$carousel.hasClass('slick-initialized')) {
        $that.nodes.$carousel.slick('unslick').removeClass('slick-vertical');
      }
      $that.nodes.$carousel.append($that.nodes.$slides);
    },

    initQuizLayout: function ($that) {
      var self = this;

      if (self.isMobile) {
        self.initializeAccordion($that);
      } else {
        self.initializeSlick($that);
      }
    },

    initializeAccordion: function ($that) {
      var self = this;

      $that.data('layout', 'accordion').addClass('ff-quiz-layout--accordion');
      // Remove any inline height set on formatters while on accordion view.
      $that.nodes.$modelsCarouselFormatter.css({ height: '' });
      self.setAccordionHtml($that);
      $that.nodes.$slides.removeClass('hidden');
      $that.nodes.$carousel.addClass('hidden');
      if ($that.nodes.$landingStep.length < 1) {
        self.expendAccordionStep($that, 0);
      }
    },

    setAccordionHtml: function ($that) {
      $that.nodes.$navItems.once('accordion-layout').each(function (i) {
        if ($that.hasClass('has-landing')) {
          $that.once('accordion-layout-landing').prepend($that.nodes.$landingStep);
        }
        var $navItem = $(this);
        var $tmpHtml = $that.nodes.$slides.eq(i);
        var $newNextBtn = $that.nodes.$buttonNext.first().clone(true).addClass('hidden');
        var $newResultstBtn = $that.nodes.$buttonResults.first().clone(true).addClass('hidden');

        $tmpHtml = $tmpHtml.add($newNextBtn);
        $tmpHtml = $tmpHtml.add($newResultstBtn);
        $tmpHtml.insertAfter($navItem);
        $that.nodes.$buttonNext = $that.nodes.$buttonNext.add($newNextBtn);
        $that.nodes.$buttonResults = $that.nodes.$buttonResults.add($newResultstBtn);
      });
    },

    closeAccordion: function ($that) {
      $that.nodes.$slides.slideUp('slow', function () {
        $that.nodes.$navItems.removeClass('expanded');
        $that.nodes.$buttonNext.addClass('hidden');
        $that.nodes.$buttonResults.addClass('hidden');
      });
    },

    expendAccordionStep: function ($that, step) {
      var self = this;

      if ($that.data('layout') !== 'accordion') {
        return;
      }
      var $showStep = $that.nodes.$slides.eq(step);

      $showStep.find($that.nodes.$modelsCarousel).trigger('ff-step-in-view');
      self.disableButtons($that);
      $that.nodes.$slides.filter(':visible').not($showStep).slideUp('slow');
      /* Keep this for now in case brand wants to keep the accordion in view
      $that.nodes.$slides.filter(':visible').not($showStep).slideUp( "slow", function() {
      self.scrollToElement($that.nodes.$navItems.first());
      }); */
      $showStep.slideDown('slow', function () {
        var $currentStep = $that.nodes.$navItems
          .removeClass('expanded')
          .eq(step)
          .addClass('expanded');
        var nextStepButton = $currentStep.next($that.nodes.$slides).data('nextStepButton');

        $that.data('accordionStep', $currentStep.data('stepIndex'));
        self.toggleButtons($that, nextStepButton);
        if ($currentStep.hasClass('js-foundation-finder--quiz-nav-item--1')) {
          $that.nodes.$buttonNext.eq(0).removeClass('opacity-zero js-last-question hidden');
          $that.nodes.$buttonNext.eq(0).addClass('disabled');
        }
      });
    },

    scrollToElement: function ($elem) {
      var scroll = $elem.offset();

      if (scroll < 100) {
        scroll = 0; // if the offset is under 100, we just get weird jumping due to stick header, just scroll up.
      }
      $('html').animate(
        {
          scrollTop: scroll
        },
        shorterInterval
      );
    },

    disableButtons: function ($that) {
      $that.nodes.$buttonNext.addClass('disabled hidden');
      $that.nodes.$buttonResults.addClass('disabled hidden');
    },

    setMatchHeights: function ($that) {
      var maxHeight = 0;
      var outerHeight = 0;

      $that.nodes.$slides.each(function () {
        var $this = $(this);

        outerHeight = 0;
        $this.children().each(function () {
          var $children = $(this);

          outerHeight += $children.outerHeight(true);
        });
        if (maxHeight < outerHeight) {
          maxHeight = outerHeight;
        }
      });
      $that.nodes.$slides.height(maxHeight);
      $that.nodes.$carousel.addClass('match-height-processed');
      var maxWidth = 0;

      $that.nodes.$answer.each(function () {
        var $this = $(this);

        if (maxWidth < $this.width()) {
          maxWidth = $this.width();
        }
      });
    },

    setEvents: function ($that) {
      var self = this;

      $that.nodes.$carousel.on('ff-slider.redoHeight', function () {
        self.setMatchHeights($that);
      });
      $that.nodes.$landingStep
        .find('a')
        .once('landign-step-anchor')
        .on('click', function (e) {
          e.preventDefault();
          if (!self.isMobile) {
            $that.nodes.$carouselWrapper.css({ height: $that.nodes.$landingStep.height() });
          }
          $that.nodes.$carousel.css({ height: '' });
          $that.nodes.$landingStep.slideUp('slow', function () {
            if ($that.data('layout') === 'carousel') {
              // Remove inline css, required only for landing view.
              $that.nodes.$carouselWrapper.css({ height: '' });
              $that.nodes.$buttonNext.removeClass('hidden');
            }
            if ($that.data('layout') === 'accordion') {
              self.expendAccordionStep($that, 0);
            }
          });
          $that.nodes.$footerContainer.removeClass('hidden');
          $that.nodes.$navItems.first().parent().removeClass('hidden');
        });

      // Navigation breadcrumbs.
      $that.nodes.$navItems.once().on('click', function (e) {
        var $navItem = $(this);
        var navIndex = $navItem.data('stepIndex');

        e.preventDefault();
        if ($navItem.hasClass('disabled')) {
          return;
        }
        $that.removeClass('on-results');
        $.event.trigger({
          type: 'foundation_finder_quiz:nav_item_click'
        });

        var increment = $that.nodes.$carousel.data('hasLandingStep') ? 1 : 0;
        var index = navIndex + increment;

        self.expendAccordionStep($that, navIndex);

        if ($that.data('layout') === 'carousel') {
          $that.nodes.$navItems.removeClass('active');
          $navItem.addClass('active');
          self.quizGoTo($that, index);
        }
        if (index === 0) {
          if (self.isMobile) {
            $that.nodes.$buttonNext.eq(0).removeClass('opacity-zero js-last-question hidden');
            $that.nodes.$buttonNext.eq(0).addClass('disabled');
          } else {
            $that.nodes.$buttonNext.removeClass('opacity-zero js-last-question hidden');
            $that.nodes.$buttonNext.addClass('disabled');
          }
          $that.nodes.$legal.removeClass('hidden');
          $that.nodes.$quickMatchWrapper.removeClass('hidden');
        }
        $that.removeClass('product-count-zero');
      });

      $that.on('gotoNext', function () {
        if ($that.data('layout') === 'carousel') {
          $that.nodes.$carousel.slick('slickNext');
          var $slickTrack = $('.slick-track');
          var currentStepIndex = $slickTrack.children().filter('.slick-current').data('slickIndex');
          // If currentStepIndex > 1 hide button.
          var nextStepButton = $slickTrack
            .children()
            .filter('.slick-current')
            .find('.foundation-finder--quiz__slide')
            .data('nextStepButton');

          self.enableNavMenu($that, currentStepIndex);
          self.toggleButtons($that, nextStepButton);
        } else {
          var $currentStep = $that.nodes.$navItems.filter('.expanded');
          var nextStep = $currentStep.data('stepIndex') + 1;

          self.enableNavMenu($that, nextStep);
          self.expendAccordionStep($that, nextStep);
        }
      });

      // Next button actions.
      $that.nodes.$buttonNext.once().on('click', function () {
        var $next = $(this);
        $(document).trigger('Next');
        if ($next.hasClass('disabled')) {
          return;
        }
        $that.nodes.$buttonNext.addClass('opacity-zero');
        $that.nodes.$legal.addClass('hidden');
        $that.nodes.$quickMatchWrapper.addClass('hidden');
        if ($next.hasClass('js-last-question')) {
          $that.addClass('on-results');
          self.onResults($that);
        } else {
          $that.removeClass('on-results');
          if ($next.hasClass('disabled')) {
            return;
          }
          $that.nodes.$title.removeClass('hidden');
          self.disableButtons($that);
          $that.trigger('gotoNext');
        }
      });

      // Event for answer box click.
      $that.nodes.$answer.once('ff-quiz-answer').on('click', function (e) {
        e.preventDefault();
        $that.nodes.$buttonNext.removeClass('disabled');
        if ($(this).hasClass('js-foundation-finder__models-slide')) {
          // The slider has it's own event's don't need to select it from here.
          return;
        }
        self.selectAnswer($(this), $that);
        $that.nodes.$buttonNext.trigger('click');
      });
      // Event for answer box click.
      $that.nodes.$answer.on('ff-quiz-select-answer', function () {
        self.selectAnswer($(this), $that);
      });

      $that.nodes.$quickMatch.on('click', function () {
        $.event.trigger({
          type: 'foundation_finder_quiz:init_quickMatch'
        });
      });

      $(document).on('foundation_finder_results_panel:init_quickMatchResults', function () {
        $that.addClass('on-results');
        $that.nodes.$navItems.addClass('hidden');
        $that.nodes.$navMenu.addClass('shortened');
        $that.nodes.$legal.addClass('hidden');
        $that.nodes.$resultsHeader.find('div').eq(1).addClass('hidden');
        $that.nodes.$navMenu.addClass('quick-match');
        $that.nodes.$quickMatchHeader.removeClass('hidden');
        $that.nodes.$quickMatchWrapper.addClass('hidden');
        self.onResults($that);
      });

      $that.nodes.$buttonResults.on('click', function (event) {
        event.preventDefault();
        $(document).trigger('Next');
        if ($(this).hasClass('disabled')) {
          return;
        }
        var answers = {};
        var payload = {};

        $that.nodes.$question.each(function () {
          var $question = $(this);
          var $answer = $question.find($that.nodes.$answer).filter('.selected-answer');
          var answerKey = $answer.data('answer') || $answer.data('answerKey');

          answerKey = typeof answerKey === 'string' ? answerKey.toLowerCase() : answerKey;
          answers[$question.data('question-key')] = answerKey;
        });
        $that.addClass('results-loaded');
        if ($that.data('layout') === 'accordion') {
          self.closeAccordion($that);
        }
        $that.nodes.$carouselWrapper.data('origHeight', $that.nodes.$carouselWrapper.height());
        $that.nodes.$carouselWrapper.animate(
          {
            height: 0
          },
          mediumInterval,
          function () {
            $(this).addClass('collapsed ff-quiz--edit');
          }
        );
        $that.nodes.$navItems.removeClass('active');
        $('html').animate(
          {
            scrollTop: 0
          },
          shortestInterval
        );
        // Call out to results, Old way.
        if (site.foundationFinder) {
          site.foundationFinder.initResults(document, answers);
        }

        // Call out to our new results template.
        payload['document'] = document;
        payload['answers'] = answers;
        $.event.trigger({
          type: 'foundation_finder_quiz:init_results',
          payload: payload
        });
        $(document).trigger('filterResult');
      });
      $that.nodes.$resetQuizBtn.once().on('click', function (event) {
        event.preventDefault();
        $.event.trigger({
          type: 'foundation_finder_quiz:start_over_click'
        });
        self.resetQuiz($that);
        $that.removeClass('on-results');
        $that.nodes.$navItems.removeClass('hidden');
        $that.nodes.$navMenu.removeClass('shortened');
        $that.nodes.$buttonNext.removeClass('opacity-zero js-last-question');
        $that.nodes.$legal.removeClass('hidden');
        $that.nodes.$quickMatchWrapper.removeClass('hidden');
        $that.nodes.$resultsHeader.removeClass('hidden');
        $that.nodes.$resultsHeader.find('div').eq(1).removeClass('hidden');
        $that.nodes.$navMenu.removeClass('quick-match');
        $that.nodes.$quickMatchHeader.addClass('hidden');
        self.disableButtons($that);
        $that.removeClass('product-count-zero');
      });

      $(document).on('foundation_finder_quiz:start_over_secondary_click', function () {
        $that.nodes.$resetQuizBtn.trigger('click');
      });

      $(document).on('foundation_finder_results_panel:product_count_zero', function () {
        $that.addClass('product-count-zero');
      });
    },
    onResults: function ($that) {
      var self = this;
      var answers = {};
      var payload = {};

      if ($that.nodes.$title.hasClass('js-hide-results')) {
        $that.nodes.$title.addClass('hidden');
      }
      $(document).trigger('Next');
      $that.nodes.$question.each(function () {
        var $question = $(this);
        var $answer = $question.find($that.nodes.$answer).filter('.selected-answer');
        var answerKey = $answer.data('answer') || $answer.data('answerKey');

        answerKey = typeof answerKey === 'string' ? answerKey.toLowerCase() : answerKey;
        answers[$question.data('question-key')] = answerKey;
      });
      $that.addClass('results-loaded');
      if ($that.data('layout') === 'accordion') {
        self.closeAccordion($that);
      }
      $that.nodes.$carouselWrapper.data('origHeight', $that.nodes.$carouselWrapper.height());
      if ($that.data('layout') === 'carousel') {
        $('html').animate(
          {
            scrollTop: 0
          },
          shortInterval
        );
      }
      $that.nodes.$carouselWrapper.animate(
        {
          height: 0
        },
        mediumInterval,
        function () {
          $(this).addClass('collapsed ff-quiz--edit');
        }
      );
      $that.nodes.$navItems.removeClass('active');
      // Call out to results, Old way.
      if (site.foundationFinder) {
        site.foundationFinder.initResults(document, answers);
      }

      $('html').animate(
        {
          scrollTop: 0
        },
        shortestInterval
      );
      // Call out to our new results template.
      payload['document'] = document;
      payload['answers'] = answers;
      $.event.trigger({
        type: 'foundation_finder_quiz:init_results',
        payload: payload
      });
      $(document).trigger('filterResult');
    },
    quizGoTo: function ($that, index) {
      var self = this;
      var nextStepButton;

      if (self.isMobile) {
        self.expendAccordionStep($that, 0);
      } else {
        if ($that.nodes.$carouselWrapper.hasClass('collapsed')) {
          $that.nodes.$carousel.css({ display: '' });
          $that.nodes.$carouselWrapper.animate(
            {
              height: $(this).data('origHeight')
            },
            mediumInterval,
            function () {
              $(this).removeClass('collapsed').css({ height: '' });
            }
          );
        }
        self.disableButtons($that);
        $that.nodes.$carousel.slick('slickGoTo', index);
      }
      $that.nodes.$slides.eq(index).find($that.nodes.$modelsCarousel).trigger('ff-step-in-view');
      nextStepButton = $that.nodes.$slides.eq(index).data('nextStepButton');
      self.toggleButtons($that, nextStepButton);
    },
    resetQuiz: function ($that) {
      var self = this;

      generic.jsonrpc.fetch({
        method: 'quiz.reset_quiz',
        params: [{ type: 'foundation_finder' }],
        onSuccess: function (jsonRpcResponse) {
          $that.nodes.$carouselWrapper.removeClass('ff-quiz--edit');
          $that.nodes.$answer.removeClass('selected-answer');
          $that.removeClass('results-loaded');
          $that.nodes.$navItemText.html('');
          $that.nodes.$modelsCarousel.trigger('ff-quiz-reset-quiz');
          $that.nodes.$navItems.removeClass('selected');
          $that.nodes.$navItems.addClass('disabled');
          $that.nodes.$navItems.eq(0).removeClass('disabled').addClass('active');
          self.quizGoTo($that, 0);
        }
      });
    },

    enableNavMenu: function ($that, enableStep) {
      $that.nodes.$navItems.eq(enableStep).removeClass('disabled');
    },

    toggleButtons: function ($that, nextButtonOption) {
      var self = this;
      var toggleIndex = 0;
      var removeClass = 'hidden';
      var $currentAnswer = $();

      if ($that.data('layout') === 'accordion') {
        toggleIndex = $that.data('accordionStep');
        $currentAnswer = $that.nodes.$slides.eq(toggleIndex).find('.selected-answer');
      } else if ($that.data('layout') === 'carousel') {
        $currentAnswer = $that.nodes.$slides.filter('.slick-current').find('.selected-answer');
      }
      if (nextButtonOption === 'results' || $that.hasClass('results-loaded')) {
        $that.nodes.$buttonNext.eq(toggleIndex).addClass('hidden');
        $that.nodes.$buttonNext.addClass('js-last-question');
      } else if (toggleIndex === 0) {
        $that.nodes.$buttonNext.eq(toggleIndex).removeClass(removeClass);
        $that.nodes.$buttonNext.removeClass('js-last-question');
        $that.nodes.$buttonResults.eq(toggleIndex).addClass('hidden');
      }
      if ($currentAnswer.length > 0) {
        self.enableButtons($currentAnswer, $that);
      }
    },

    selectAnswer: function ($answer, $that) {
      var self = this;
      var $allAnswers = $answer.closest($that.nodes.$question).find($that.nodes.$answer);

      $answer.data('questionIndex', $answer.closest($that.nodes.$slides).data('questionIndex'));
      self.addTextToNavigation($answer, $that);
      self.highlightSelected($answer, $allAnswers);
      self.enableButtons($answer, $that);
    },

    enableButtons: function ($answer, $that) {
      var self = this;
      var pendingQuestions = $that.nodes.$navItems.filter(':not(.selected)').length > 0;

      if (!!$answer) {
        var showResults =
          $answer.data('questionIndex') === $that.nodes.$question.length - 1 ||
          $that.hasClass('results-loaded');

        if (showResults && !pendingQuestions) {
          $that.nodes.$buttonResults.css('z-index', 2).removeClass('disabled');
        }
        if (!showResults) {
          self.enableNavMenu($that, $answer.data('questionIndex') + 1);
          var nextBtnIndex =
            $that.data('layout') === 'accordion' ? $answer.data('questionIndex') : 0;

          $that.nodes.$buttonNext.eq(nextBtnIndex).css('z-index', 2).removeClass('disabled');
        }
      }
    },

    addTextToNavigation: function ($answer, $that) {
      var slideIndex = $answer.data('questionIndex');
      var answerId = $answer.data('answerKey');
      var answerText = $answer.data('navText')
        ? $answer.data('navText')
        : $answer.data('translatedAnswer')
          ? $answer.data('translatedAnswer')
          : '';

      answerText = answerText.replace(/(<([^>]+)>)/gi, '');
      var navText = answerText || answerId;
      var $currentMenu = $that.nodes.$navItems.eq(slideIndex).addClass('selected');

      $currentMenu.find($that.nodes.$navItemText).text(navText);
    },

    highlightSelected: function ($answer, $allAnswers) {
      $allAnswers.removeClass('selected-answer');
      $answer.addClass('selected-answer');
    },

    initializeSlick: function ($that) {
      var self = this;

      // Hide mobile accordion items if present.
      if ($that.nodes.mobileNavItems) {
        $that.nodes.mobileNavItems.each(function () {
          if (!$(this).hasClass('hidden')) {
            $(this).addClass('hidden');
          }
        });
      }
      $that.data('layout', 'carousel').addClass('ff-quiz-layout--carousel');
      $that.nodes.$slides.removeClass('hidden');
      $that.nodes.$carousel.trigger('ff-slider.slidesVisible');
      self.setMatchHeights($that);
      $that.nodes.$carousel.slick(self.settings);
    }
  };
})(jQuery);
